import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput, SelectChangeEvent } from '@mui/material';

interface MultiSelectProps {
  label: string;
  options: { id: string; name: string }[];
  selected: string[];
  setSelected: (selected: string[]) => void;
}

const MultiSelect: React.FC<MultiSelectProps> = ({ label, options, selected, setSelected }) => {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    setSelected(event.target.value as string[]);
  };

  return (
    <FormControl fullWidth margin="normal">
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={selected}
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) =>
          options
            .filter((option) => (selected as string[]).includes(option.id))
            .map((option) => option.name)
            .join(', ')
        }
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox checked={selected.includes(option.id)} />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelect;